module.exports = __webpack_public_path__ + "img/spitter-die-mask-2.9b66c2e1.png";